/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('leaflet');
require('cookieconsent');


Vue = window.Vue = require('vue');
Vue.component('impressions', require('./components/Impressions'));
Vue.component('news', require('./components/News'));

function loadCookies() {
    if (!(navigator.doNotTrack != 1 && navigator.doNotTrack != "yes" && window.doNotTrack != 1 && navigator.msDoNotTrack != 1)) {
        return;
    }

    loadGAonConsent();
}

function gtag() {
    dataLayer.push(arguments);
}

function loadGAonConsent() {
    let gaProperty = 'UA-148761410-1';
    let disableStr = 'ga-disable-' + gaProperty;

    if (document.cookie.indexOf(disableStr + '=true') > -1) {
        window[disableStr] = true;
    }

    $.getScript('https://www.googletagmanager.com/gtag/js?id=' + gaProperty);
    window.dataLayer = window.dataLayer || [];

    gtag('js', new Date());
    gtag('config', gaProperty, {'anonymize_ip': true});
}

function gaOptout() {
    document.cookie = disableStr + '=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/';
    window[disableStr] = true;
    alert('Google Analytics deaktiviert.');
}

window.cookieconsent.initialise({
    "palette": {
        "popup": {
            "background": "#001f4b",
            "text": "#fff"
        },
        "button": {
            "background": "#dc2b33"
        }
    },
    "theme": "classic",
    "type": "opt-in",
    "position": "bottom-right",
    "content": {
        "message": "Wir nutzen Cookies und Google Analytics, um diese Website für Sie so interessant wie möglich zu gestalten. Sind Sie damit einverstanden? (Sie können diese Entscheidung jederzeit widerrufen)",
        "deny": "Ablehnen",
        "allow": "Akzeptieren",
        "link": "Datenschutzerklärung",
        "href": "/datenschutz"
    },

    onStatusChange: function (status, chosenBefore) {
        console.log("status change");
        var type = this.options.type;
        var didConsent = this.hasConsented();
        if (type === 'opt-in' && didConsent) {
            // enable cookies
            loadCookies();
        }
        setTimeout(() => {
            this.toggleRevokeButton(false);
        }, 500);

    }
}, function (popup) {
    popup.toggleRevokeButton(false);
});

if (document.cookie.split(';').filter(function (item) {
    return item.indexOf('cookieconsent_status=allow') >= 0;
}).length) {
    loadCookies();
}

function toggleDropdown(e) {
    const _d = $(e.target).closest('.dropdown'),
        _m = $('.dropdown-menu', _d);
    setTimeout(function () {
        const shouldOpen = e.type !== 'click' && _d.is(':hover');
        _m.toggleClass('show', shouldOpen);
        _d.toggleClass('show', shouldOpen);
        $('[data-toggle="dropdown"]', _d).attr('aria-expanded', shouldOpen);
    }, e.type === 'mouseleave' ? 300 : 0);
}

$('body')
    .on('mouseenter mouseleave', '.dropdown', toggleDropdown)
    .on('click', '.dropdown-menu a', toggleDropdown);



// WEBPACK FOOTER //
// ./resources/js/app.js